module.exports = __webpack_public_path__ + "img/engineering-io-blue-horizontal.35805a2e.svg";